import esUS from '../../date-picker/locale/es_US';
export default esUS;
